<template>
  <q-toggle
      v-if="user.id"
      v-model="user.receive_letters"
      @change="attachUser(user)"
  >
    <q-tooltip>
      {{ user.receive_letters ? 'Отключить' : 'Включить' }} отправку писем
    </q-tooltip>
  </q-toggle>
</template>

<script>
import {
  QField,
  QInput,
  QToggle,
  QBtn,
  QTooltip,
  QPopover,
  QList,
  QItem,
  QInfiniteScroll,
  QSpinnerDots,
} from 'quasar';

import projectUser from "../../mixins/projectUser/projectUser";

export default {
  name: "ProjectUserLetterToggler",

  components: {
    QField,
    QInput,
    QToggle,
    QBtn,
    QTooltip,
    QPopover,
    QList,
    QItem,
    QInfiniteScroll,
    QSpinnerDots,
  },

  props: {
    user: {
      type: Object,
      required: true,
    }
  },

  mixins: [
    projectUser,
  ],
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectUsersList/ProjectUserLetterToggler.vue